export const PAGE_SIZES = [10, 15, 20];
export const PAGE_SIZE = 15;
